inputs-without-label-checkall
  span.btn-checkall.btn.btn-sm.btn-primary(onClick="{onClickCheckall}")
    i.feather.icon-check-square
    | {this.locale().checkall}
  span.btn-uncheckall.btn.btn-sm.btn-primary(onClick="{onClickUncheckall}")
    i.feather.icon-square
    | {this.locale().uncheckall}
  script(type="typescript").
    this.mixin('inputs.checkall')
  style(scoped).
    .btn-uncheckall {
      margin-left: 1px;
    }
